import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { api } from "../api";
import { useTitel } from "../titel";

export default function Anmelden() {
  useTitel("Anmelden");
  const [email, setEmail] = useState("");
  const [passwort, setPasswort] = useState("");
  const [fehler, setFehler] = useState<string | null>(null);
  const [laeuft, setLaeuft] = useState(false);
  const navigate = useNavigate();
  const client = useQueryClient();

  async function absenden(e: FormEvent) {
    e.preventDefault();
    setFehler(null);
    setLaeuft(true);
    try {
      const benutzer = await api.anmelden(email, passwort);
      client.setQueryData(["ich"], benutzer);
      // Wer eine eigene Person im Stammbaum hat, startet dort.
      navigate(benutzer.personId ? `/person/${benutzer.personId}` : "/suche", { replace: true });
    } catch (f) {
      setFehler(f instanceof Error ? f.message : "Anmeldung fehlgeschlagen.");
    } finally {
      setLaeuft(false);
    }
  }

  return (
    <div className="mx-auto mt-24 max-w-sm px-4">
      <h1 className="text-2xl font-semibold tracking-tight">Stammbaum</h1>
      <p className="mt-1 text-sm text-black/50 dark:text-white/50">Bitte anmelden.</p>

      <form onSubmit={absenden} className="mt-6 space-y-4">
        <label className="block">
          <span className="text-sm text-black/60 dark:text-white/60">E-Mail</span>
          <input
            type="email"
            autoComplete="username"
            required
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full rounded-lg border border-black/15 bg-white px-3 py-2
                       outline-none focus:border-black/40 dark:border-white/15 dark:bg-neutral-800"
          />
        </label>

        <label className="block">
          <span className="text-sm text-black/60 dark:text-white/60">Passwort</span>
          <input
            type="password"
            autoComplete="current-password"
            required
            value={passwort}
            onChange={(e) => setPasswort(e.target.value)}
            className="mt-1 w-full rounded-lg border border-black/15 bg-white px-3 py-2
                       outline-none focus:border-black/40 dark:border-white/15 dark:bg-neutral-800"
          />
        </label>

        {fehler && (
          <p role="alert" className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-800">
            {fehler}
          </p>
        )}

        <button
          type="submit"
          disabled={laeuft}
          className="w-full rounded-lg bg-tinte px-3 py-2 text-white
                     disabled:opacity-50 dark:bg-white dark:text-tinte"
        >
          {laeuft ? "…" : "Anmelden"}
        </button>
      </form>

      <p className="mt-6 text-xs text-black/40 dark:text-white/40">
        Zugänge legt der Besitzer des Stammbaums an — auf dem Server mit
        <code className="mx-1">npm run benutzer</code>. Eine Selbstregistrierung
        gibt es bewusst nicht.
      </p>
    </div>
  );
}
